// extracted by mini-css-extract-plugin
module.exports = {"first":"Chart1_first__2bi58","second":"Chart1_second__1LQ3Z","third":"Chart1_third__l8X3e"};